import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import '../../components/css/transfer.css';
import contactImage from "../../assets/static/global/profile_settings.png";

function ContactUsTemplate() {
  return (
    <div>
      <Container fluid className="my-5 bg-custom">
        <Container className='container-padding'>
          <Row className="flex-column flex-md-row">
            {/* Image column */}
            <Col md={6} className="order-2 order-md-1">
              <img
                src={contactImage}
                alt="Contact Us"
                className="img-fluid"
              />
            </Col>

            {/* Text column */}
            <Col md={6} className="d-flex align-items-center order-1 order-md-2">
              <div>
                {/* <h1 className='custom_heading'>Contact Kontriman Cooperative Credit Union</h1> */}
                <p><strong>Fraud Department:</strong> fraud@kontriman.com</p>
                <p><strong>General Inquiries:</strong> enquiries@kontriman.com</p>
                <p><strong>Support & Info:</strong> info@kontriman.com</p>
                <p><strong>Phone:</strong> <a href="https://wa.me/237640375069" target="_blank" rel="noopener noreferrer">+237 64 037 5069 (WhatsApp)</a> | +237 68 269 2422</p>

                <h5 className='mt-4'>HEAD OFFICE</h5>
                <p>04 Weladji Building, Half Mile, Limbe South West Region, Republic of Cameroon</p>

                <h5 className='mt-4'>Authorised Financial Services Provider</h5>
                <p><strong>MINADER:</strong> 23/049/CMR/SW/53/279/CCA/036004/03600400</p>
                <p><strong>COBAC:</strong> D-2024/354</p>
                <p><strong>MINFI:</strong> 00000041/2024</p>
                <p><strong>NIU:</strong> M042318452491L</p>

                <a href="mailto:info@kontriman.com">
                  <Button className='custom-button mt-3'>Email Us</Button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default ContactUsTemplate;
